__turbopack_context__.v({
  "content": "ConfirmModal-module-scss-module__qqU53q__content",
  "copy": "ConfirmModal-module-scss-module__qqU53q__copy",
  "danger": "ConfirmModal-module-scss-module__qqU53q__danger",
  "description": "ConfirmModal-module-scss-module__qqU53q__description",
  "footer": "ConfirmModal-module-scss-module__qqU53q__footer",
  "icon": "ConfirmModal-module-scss-module__qqU53q__icon",
  "message": "ConfirmModal-module-scss-module__qqU53q__message",
});
